import { Track } from "./_/track";
import gsap from "../gsap";

const scale = 1.2;

export class Parallax extends Track {
  move;
  #setY = [];

  constructor(element) {
    super(element, {
      top: "bottom",
      bottom: "top",
      bounds: [-1, 1],
    });

    this.move = Array.from(this.element.querySelectorAll("[data-move]"));
    this.move.forEach((item) => {
      gsap.set(item, { scale });
      this.#setY.push(gsap.quickSetter(item, "y", "%"));
    });
  }

  handleScroll = (value) => {
    this.#setY.forEach((setY) => setY(value * 20));
  };

  transitionOut = () => {
    this.destroy();
  };
}

